// extracted by mini-css-extract-plugin
var _1 = "tAyVQ99hJX8hL2g4zQ9m";
var _2 = "DGW3ialg95zgormlDcZZ";
var _3 = "m6_BI9ny2fmY4vxxCT3W";
var _4 = "BLEE9c8aboyNwEjDhHwV";
var _5 = "i1PAc66e5J5rBL1cKlv5";
var _6 = "LchdL8_ffj8ZP_iFLDmT";
var _7 = "ineQCD8jqgX59PcVLSwl";
var _8 = "SJVIIK2SwkZQlr4eIIlK";
var _9 = "f8UJQiTA62Ukt7aDqWBK";
var _a = "eVgKGCqxDBHOkcxayyzG";
var _b = "ysoM3e7HCqWi5R0XC7ib";
var _c = "bQhowxcFP_nKxswbo5TI";
var _d = "vRrzZnYhTWERjSI4R0Ya";
var _e = "NteuwNCQGml9Ww9WEAgv";
export { _1 as "addToCart", _2 as "columns", _3 as "details", _4 as "edit", _5 as "editButton", _6 as "editor", _7 as "img", _8 as "inlineEdit", _9 as "input", _a as "price", _b as "remove", _c as "sizes", _d as "title", _e as "work" }
